
// This file is deprecated and will be removed in the future.
// Use imports from '@/contexts/country' instead.
// 
// Example:
// import { useCountry } from '@/contexts/country';

import { 
  CountryProvider as NewCountryProvider, 
  useCountry as newUseCountry
} from './country';
import type { Country } from './country/types';

// Re-export the types from the new context to maintain compatibility
export type { Country };

// Re-export the hook and provider with the same names
export const CountryProvider = NewCountryProvider;
export const useCountry = newUseCountry;
